import { Client } from '@/pages/user/api';
let apiPrefix = 'portal';

/**
 * 文件查询
 */
export const QueryFiles = async (data: Object): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/web/netdisk/queryFiles',
    data,
  });
};

/**
 * 文件夹查询
 */
export const QueryFolder = async (data: Object): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/web/netdisk/queryFolder',
    data,
  });
};

/**
 * 新建文件夹
 */
export const SaveFolder = async (data: any): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/web/netdisk/saveFolder',
    data,
  });
};

/**
 * 文件保存
 */
export const SaveFile = async (data: any): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/web/netdisk/saveFile',
    data,
  });
};
/**
 * 文件移动
 */
export const MoveFile = async (data: any): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/web/netdisk/moveFile',
    data,
  });
};

/**
 * 文件删除
 */
export const DeleteFile = async (data: any): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/web/netdisk/deleteFile',
    data,
  });
};

/**
 * 应用详情
 */
export const QueryAppByCode = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/apps/queryAppByCode',
    data,
  });
};
/**
 * 应用列表
 */
export const QueryAllApps = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/apps/queryAll',
  });
};
